import React, { useContext } from "react";
import { RegistrationFormContext } from "./types";
import { InputCheckbox } from "../../../../HtmlComponents/InputCheckbox";
import { TextAreaElement } from "../../../../HtmlComponents/TextAreaElement";

const Section12 = () => {
  const {
    regOrderList, setRegOrderList,
    otherCountries, setOtherCountries,
    jurisdictionalPenalties, setJurisdictionalPenalties,
  } = useContext(RegistrationFormContext);

  return (<>
    <div>
      <p className='font-bold text-main'>{"44) "}Avez-vous été inscrit à un tableau de l'ordre: </p>
      <InputCheckbox 
        name="Oui"
        id="regOrderList" 
        checked={regOrderList === "Oui"} 
        value={regOrderList} 
        setValue={setRegOrderList}
      />
      {(regOrderList || typeof regOrderList === "string") && <TextAreaElement textAreaClass='md:w-1/2' name='Laquelle?' value={regOrderList} setValue={setRegOrderList}/>}
    </div>
    <div>
      <p className='font-bold text-main'>{"45) "}Avez-vous exercé dans d'autres pays: </p>
      <InputCheckbox 
        name="Oui"
        id="otherCountries" 
        checked={otherCountries === "Oui"} 
        value={otherCountries} 
        setValue={setOtherCountries}
      />
      {(otherCountries || typeof otherCountries === "string") && <TextAreaElement textAreaClass='md:w-1/2' name='Laquelle?' value={otherCountries} setValue={setOtherCountries}/>}
    </div>
    <div>
      <p className='font-bold text-main'>{"46) "}Avez-vous encouru des peines prononcées par la juridiction de l'ordre: </p>
      <InputCheckbox 
        name="Oui"
        id="jurisdictionalPenalties" 
        checked={jurisdictionalPenalties === "Oui"} 
        value={jurisdictionalPenalties} 
        setValue={setJurisdictionalPenalties}
      />
      {(jurisdictionalPenalties || typeof jurisdictionalPenalties === "string") && <TextAreaElement textAreaClass='md:w-1/2' name='Laquelle?' value={jurisdictionalPenalties} setValue={setJurisdictionalPenalties}/>}
    </div>
  </>);
};

export default Section12;
